module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"on-stage":"on stage","move-here":"Move here","move":"Move","here":"Here"},"pt-BR":{"on-stage":"no estágio","move-here":"Mover aqui","move":"Mover","here":"Aqui"}}')
  delete Component.options._Ctor
}
